"use client";

import { useParams, notFound } from "next/navigation";
import useCustomPage from "../_hooks/useCustomPage";
import PageSkeleton from "../skeleton/PageSkeleton";
import PageContent from "@/app/_partials/PageContent";

export function CustomPageClientWrapper({ slug }) {
    const { page, loading } = useCustomPage(slug);

    if (loading) return <PageSkeleton />;

    if (!page) return notFound();

    const sections = page?.data?.page?.secs;

    return <PageContent slug={slug} sections={sections} />;
}
